import { useState } from 'react';
import './ShareModal.css';

function ShareModal({ notebookId, notebookName, onClose }) {
    const [copied, setCopied] = useState(false);

    const shareUrl = `${window.location.origin}/notebook/${notebookId}`;

    const handleCopyLink = () => {
        navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="share-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Share "{notebookName}"</h3>
                    <button onClick={onClose} className="close-btn">×</button>
                </div>

                <div className="modal-body">
                    <div className="share-link-section">
                        <label>Anyone with the link can view</label>
                        <div className="link-input-group">
                            <input
                                type="text"
                                value={shareUrl}
                                readOnly
                                className="share-link-input"
                            />
                            <button onClick={handleCopyLink} className="copy-btn">
                                {copied ? '✓ Copied' : 'Copy'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ShareModal;
